module.exports = __webpack_public_path__ + "static/sport/bg.4eeadbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg.png
// module id = 3Y69
// module chunks = 0